import React from "react";

type CasperDashProps = {};

export const CasperDash: React.FC<CasperDashProps> = () => {
  return <div>CasperDash</div>;
};
